/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteUserFavoriteMediaResponse } from '../../models/delete-user-favorite-media-response';

export interface UserServiceDeleteUserFavoriteMedia$Params {
  userUuid: string;
  discordId?: string;
}

export function userServiceDeleteUserFavoriteMedia(http: HttpClient, rootUrl: string, params: UserServiceDeleteUserFavoriteMedia$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteUserFavoriteMediaResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceDeleteUserFavoriteMedia.PATH, 'delete');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.query('discordId', params.discordId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteUserFavoriteMediaResponse>;
    })
  );
}

userServiceDeleteUserFavoriteMedia.PATH = '/api/v3/gateway/user/{userUuid}/favorite/media';
